import { EDITS_IMGIX_HOSTNAMES } from '@air/feature-edit-canvas';

const UUID_PATTERN = /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;

/** `{workspaceId}/{taskId}.{ext}`, where an unsaved `clipVideo` task writes its output in the edits bucket. */
const TEMPORARY_CUT_KEY_PATTERN = /^([^/]+)\/([^/.]+)\.[a-z0-9]+$/i;

export type TemporaryVideoCut = {
  fileName: string | undefined;
  taskId: string;
};

type GetTemporaryVideoCutParams = {
  fileName: string | undefined;
  url: string | undefined;
  workspaceId: string;
};

export const getTemporaryVideoCut = ({
  fileName,
  url,
  workspaceId,
}: GetTemporaryVideoCutParams): TemporaryVideoCut | null => {
  if (!url) {
    return null;
  }

  try {
    const parsed = new URL(url);

    if (!EDITS_IMGIX_HOSTNAMES.has(parsed.hostname)) {
      return null;
    }

    const match = TEMPORARY_CUT_KEY_PATTERN.exec(parsed.pathname.slice(1));
    const keyWorkspaceId = match?.[1];
    const taskId = match?.[2];

    if (
      !taskId ||
      !keyWorkspaceId ||
      !UUID_PATTERN.test(taskId) ||
      !UUID_PATTERN.test(keyWorkspaceId) ||
      keyWorkspaceId.toLowerCase() !== workspaceId.toLowerCase()
    ) {
      return null;
    }

    return { fileName, taskId };
  } catch {
    return null;
  }
};

/** One cut per task, so saving the same trim from several nodes does not create duplicate assets. */
export const uniqueTemporaryVideoCuts = (cuts: TemporaryVideoCut[]): TemporaryVideoCut[] =>
  Array.from(new Map(cuts.map((cut) => [cut.taskId, cut])).values());
